import cn from 'classnames'
import { AllHTMLAttributes, ElementType, forwardRef } from 'react'

import styles from './Label.module.scss'

export type PaddingOptions = 0 | 1 | 2 | 3

export interface LabelProps extends Omit<AllHTMLAttributes<HTMLElement>, 'as' | 'size'> {
  as?: ElementType
  icon?: React.ReactNode
  endIcon?: React.ReactNode
  interactive?: boolean
  variant?: 'light' | 'dark' | 'highlight' | 'plain' | 'lavender' | 'black' | 'secondary'
  size?: 'md' | 'sm'
  borderRadius?: 'radius-xs' | 'radius-sm' | 'radius-md' | 'radius-lg' | 'radius-xl'
  highlight?: boolean
  bordered?: boolean
  primary?: boolean
  padding?: PaddingOptions
  iconClassName?: string
  endIconClassName?: string
  endIconAlignRight?: boolean
  fullWidth?: boolean
}

const Label = forwardRef<HTMLElement, LabelProps>(
  (
    {
      as: Element = 'div',
      icon,
      endIcon,
      type,
      variant = 'light',
      size = variant === 'plain' ? 'sm' : 'md',
      borderRadius = 'radius-lg',
      highlight,
      bordered,
      primary,
      className,
      children,
      interactive,
      padding,
      iconClassName,
      endIconClassName,
      endIconAlignRight,
      fullWidth,
      ...props
    },
    ref
  ) => (
    <Element
      ref={ref}
      type={Element === 'button' ? type || 'button' : undefined}
      className={cn(
        styles.root,
        styles[variant],
        styles[size],
        styles[borderRadius],
        highlight && styles.highlight,
        bordered && styles.bordered,
        primary && styles.primary,
        interactive && styles.interactive,
        fullWidth && styles.fullWidth,
        styles[`padding-${padding}`],
        className
      )}
      {...props}
    >
      {icon && <span className={cn(styles.icon, iconClassName)}>{icon}</span>}
      {children && <span className={styles.content}>{children}</span>}
      {endIcon && <span className={cn(styles.icon, endIconAlignRight && styles.alignRight)}>{endIcon}</span>}
    </Element>
  )
)

export default Label
